import { PersonDetailsQueryDispatch, PersonDetailsQueryState } from '../customPeopleTagTypes';

import { useQueryState } from './useQueryState';

export const usePersonDetailsQueryState = (): [PersonDetailsQueryState, PersonDetailsQueryDispatch] => (
  useQueryState<PersonDetailsQueryState>()
);
